import { validateNumber, validateString } from 'avilatek-utils';
import { PaymentMethod } from '../../models';

export function validatePaymentMethodForm({
  title,
  commission,
  currency,
  paymentData,
}: Partial<PaymentMethod>): string {
  if (!validateString(title) || String(title).length > 127) {
    return 'Nombre del método de pago es inválido';
  }

  if (!currency) {
    return 'Debe seleccionar una moneda para el método de pago';
  }

  if (commission < 0 || !validateNumber(commission)) {
    return 'La comisión del método de pago es inválida';
  }

  if (paymentData?.length <= 0) {
    return 'Debe ingresar al menos un dato para el pago';
  }

  const invalidPaymentData = paymentData?.filter((p) => !p.name || !p.value);

  if (invalidPaymentData?.length > 0) {
    const error = `El campo Nombre y Valor son requeridos en los datos para el pago`;
    return error;
  }

  return '';
}
